import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { IonicModule, MenuController, Platform } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage';
import { filter } from 'rxjs/operators';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [IonicModule, CommonModule, RouterModule, TranslateModule]
})
export class AppComponent implements OnInit {
  constructor(
    private storage: Storage,
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private translate: TranslateService
  ) {
    /* Supported languages */
    this.translate.addLangs(['en', 'th']);

    /* Restore language from localStorage or browser */
    const saved = localStorage.getItem('lang');
    const browser = this.translate.getBrowserLang() || 'th';
    this.translate.use(saved || (browser.match(/en|th/) ? browser : 'th'));
  }

  /* ═════ LANGUAGE SWITCHER ═════ */
  switchLang(lang: 'en' | 'th') {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    /* Hard-refresh to re-render static labels across pages */
    window.location.reload();
  }

  /* ═════ APP INIT ═════ */
  async ngOnInit(): Promise<void> {
    await this.storage.create();
    await this.platform.ready();
    await this.menu.close('mainMenu');

    /* Fix ion-page-invisible on route change */
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        document
          .querySelectorAll('.ion-page-invisible')
          .forEach(el => el.classList.remove('ion-page-invisible'));
      });
  }
}
